import firebase from '../config/FirebaseConfig'

// Deterministic doc id keyed by user + brand. Eliminates the read-before-write
// race where two concurrent first-pins each create a separate random-id doc.
const pinnedDocId = (userId, brandId) => `${userId}_${brandId}`
const pinnedDoc = (userId, brandId) =>
  firebase
    .firestore()
    .collection('pinned-hooks')
    .doc(pinnedDocId(userId, brandId))

export async function pinHook ({ userId, brandId, hookKey }) {
  try {
    // arrayUnion + merge is idempotent — safe under concurrent calls.
    await pinnedDoc(userId, brandId).set(
      {
        userId,
        brandId,
        hookKeys: firebase.firestore.FieldValue.arrayUnion(hookKey),
        updatedAt: new Date()
      },
      { merge: true }
    )
    return true
  } catch (error) {
    console.error('Error pinning hook:', error)
    throw error
  }
}

export async function unpinHook ({ userId, brandId, hookKey }) {
  try {
    await pinnedDoc(userId, brandId).set(
      {
        hookKeys: firebase.firestore.FieldValue.arrayRemove(hookKey),
        updatedAt: new Date()
      },
      { merge: true }
    )
    return true
  } catch (error) {
    console.error('Error unpinning hook:', error)
    throw error
  }
}

export async function clearHookPins ({ userId, brandId }) {
  try {
    await pinnedDoc(userId, brandId).set(
      {
        hookKeys: [],
        updatedAt: new Date()
      },
      { merge: true }
    )
    return true
  } catch (error) {
    console.error('Error clearing hook pins:', error)
    throw error
  }
}
